import { createStore, applyMiddleware, compose } from "redux";
import root from "../redux";
import thunkMiddleware from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  root,
  composeEnhancers(applyMiddleware(thunkMiddleware))
);

export default store;
